import React from "react";
import { checkIfPaymentIsAttachedOrNot } from "../../../components/utils";
import { useLocation } from "react-router-dom";
import useCheckMobileScreen from "../../../hooks/useCheckMobileScreen";
import { useIsDesignV2 } from "../../../hooks/useIsDesignV2";

interface IPaymentProps {
  LineHide?: any;
  MobileHide?: any;
  titleStyle: string;
  paymentDetails: any[];
  tableEndSpacing?: string;
}
const PaymentMethod: React.FunctionComponent<IPaymentProps> = ({
  LineHide,
  MobileHide,
  titleStyle,
  paymentDetails,
  tableEndSpacing,
}) => {
  const isDigital = paymentDetails[0]?.card?.is_digital_payment ? true : false;
  const isProcessedPresent = paymentDetails.some(
    (paymentMethod) => paymentMethod.is_processed
  );
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  if(!checkIfPaymentIsAttachedOrNot(paymentDetails)) return null;
 
  return (
    <>
      <div
        className={`${MobileHide} d-flex justify-content-between align-items-center ${isDesignV2 ? 'pb-0' : 'pb-4 pb-md-0'}`}
      >
        <div className="w-100">
          <h4
            className={` clr-dark-grey text-start ${titleStyle} ${isDesignV2 ? 'mt-0 lh-normal pb-1 font-Visby-cf f-sm-s15 f-w6 mb-0' : 'h-22 f-sm-s16 f-s20 pt-3'}`}
          >
            {
              isDesignV2 ? 'Payment Method' : 'Payment Information'
            }
          </h4>
          <div className="bot">
            <table className="w-100">
              <tr>
                <th className={`text-start pe-2 ${isDesignV2? 'font-Visby-cf text-uppercase f-s15' : ''}`}>Name</th>
                {/* Google/Apple Pay: Name + Status (no Card / last4). */}
                {isDigital ? (
                  <th className={`text-center px-2 ${isDesignV2? 'font-Visby-cf text-uppercase f-s15' : 'f-sm-s14'} ${tableEndSpacing ?? ''}`}>
                    Status
                  </th>
                ) : (
                  <th className={`text-start px-2 ${isDesignV2? 'font-Visby-cf text-uppercase f-s15' : ''}`}>Card</th>
                )}
                {
                  !isDigital && !isDesignV2 ?
                  <>
                  {isProcessedPresent && (
                    <th className= {`text-start px-2 ${tableEndSpacing} ${isDesignV2? 'font-Visby-cf text-uppercase f-sm-s16' : 'f-sm-s14'}`}>
                      Date
                    </th>
                  )}
                  <th className= {`text-start px-2 f-sm-s14 ${tableEndSpacing}`}>
                  Status
                </th>
                  </>
                  : null
                }
                <th className= {`text-end ps-2 ${tableEndSpacing} ${isDesignV2? 'font-Visby-cf f-sm-s15' : 'f-sm-s14'}`}>Amount</th>
              </tr>
              {paymentDetails.map((paymentMethod, index) => {
                let customerName = "";
                let last4 = "";
                let status = "";
                if (
                  paymentMethod?.card?.id ||
                  paymentMethod?.card?.is_digital_payment
                ) {
                  // Null/empty card_name (common on guest wallet/card pays) → show "Card"
                  customerName =
                    paymentMethod?.card?.card_name?.trim?.() || "Card";
                  last4 = paymentMethod?.card?.last4;
                  status =
                    paymentMethod?.card?.status ||
                    paymentMethod?.payment_status ||
                    "";
                } else if (paymentMethod.gift_card) {
                  customerName =
                    paymentMethod?.gift_card?.card_name?.trim?.() ||
                    paymentMethod?.gift_card?.name?.trim?.() ||
                    "Gift Card";
                  last4 = paymentMethod?.gift_card?.gift_card_no;
                  status =
                    paymentMethod?.gift_card?.status ||
                    paymentMethod?.payment_status ||
                    "";
                } else return null;
                return (
                  <tr key={index}>
                    <td className={`text-start pe-2 ${isDesignV2 ? 'mb-0 f-s14 f-w4 ls-05 text-capitalize' : ''}`}>{customerName}</td>
                    {isDigital ? (
                      <td className={`text-center px-2 ${isDesignV2 ? 'mb-0 f-s14 f-w4 ls-05 text-capitalize' : ''}`}>
                        {status || "-"}
                      </td>
                    ) : (
                      <td className={`text-start px-2 ${isDesignV2 ? 'mb-0 f-s14 f-w4 ls-05 text-capitalize' : ''}`}>
                        {last4 ? `Ending With ...${last4}` : "-"}
                      </td>
                    )}
                    {
                      !isDigital && !isDesignV2 ?
                      <>
                      {isProcessedPresent && (
                      <td className={`px-2 ${isDesignV2 ? 'mb-0 text-start f-s14 f-w4 ls-05 text-capitalize' : ''}`}>{paymentMethod?.processed_at}</td>
                    )}
                    <td className={`px-2 text-start`}>
                      {paymentMethod?.payment_status}
                    </td>
                      </>
                      : null
                    }
                    <td className= {`ps-2 text-end ${tableEndSpacing} ${isDesignV2 ? 'mb-0 f-s14 f-w4 ls-05 text-capitalize' : ''}`}>
                      $ {paymentMethod.amount}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
        </div>
      </div>
      <hr className={`${LineHide} custom_hr_sty d-md-block ${isDesignV2 ? 'd-block'  : 'd-none'}`} />
    </>
  );
};

export default PaymentMethod;
